// extracted by mini-css-extract-plugin
export default {"reaction-box":"Reactions_reaction-box__2gpLQ","emoji-box":"Reactions_emoji-box__FVoDh","non-reacted":"Reactions_non-reacted__UlnMO","list":"Reactions_list__bpiFX"};